import { Injectable } from '@angular/core'


@Injectable({
  providedIn: 'root'
})
export class XorService {

  private readonly key = '2344reldkfdlkso4854kdf949'
  private readonly salt = 'g<!#!>d#'

  public encode(input: string): string {
    if (input.slice(0, this.salt.length) === this.salt) return input
    const code = this.encrypt(input)
    return this.salt + code
  }

  public decode(input: string): string {
    if (input.slice(0, this.salt.length) !== this.salt) return input
    const cleanInput = input.substring(this.salt.length)
    return this.encrypt(cleanInput)
  }

  private encrypt(input: string): string {
    const key = this.key
    const output = []
    for (let i = 0; i < input.length; i++) {
      // tslint:disable-next-line:no-bitwise
      const charCode = input.charCodeAt(i) ^ key[i % key.length].charCodeAt(0)
      output.push(String.fromCharCode(charCode))
    }
    return output.join('')
  }
}
